import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { routes } from './app.routing.module';
import { ChunkLoadErrorHandler } from './chunk-load-error-handler';
import { HotRoutePreload } from './hot-route-preload';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(HotRoutePreload)),
    provideZonelessChangeDetection(),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
  ]
};
